(function () {
  'use strict';

  var PHASE_ATTRIBUTE = 'data-kjs-card-phase';
  var PHASE_VALUE = '8';
  var MIN_CHARACTERS = 2;
  var RESULT_LIMIT = 6;
  var REQUEST_LIMIT = 10;
  var DEBOUNCE_DELAY = 250;
  var CACHE_LIMIT = 20;
  var SHIPSKETCH_PRODUCT_ID = '9119770083505';
  var SHIPSKETCH_HANDLE = 'delivery-location';
  /* Small, deliberately tie-break-only boosts from the existing 90-day POS
   * shortlist. Lexical relevance and availability always remain dominant. */
  var POPULARITY_BY_HANDLE = {
    'purple-blaster-degreaser-32oz-730157292354': 3,
    'wd-40-smart-straw-12oz-490057-079567490050': 2,
    'wd-40-aerosol-8oz-w-straw-blw-079567110989': 1,
    'whitlam-all-purpose-cement-1-2-pint-8oz-688544080186': 3,
    'whitlam-all-purpose-cement-1pt-16oz-688544160185': 2,
    'all-purpose-cement-32oz-688544320183': 1,
    'led-lamp-a19-day-light-14w-660731531664': 3,
    'lamp-led-9w-daylight-660731531626': 2,
    'bulb-led-11w-a19-daylight-660731531640': 1,
    'nail-strt-common-3-10d-hd-50070010': 3,
    'nail-strt-common-21-2-8d-hd-50070008': 2,
    'nail-strt-common-2-6d-50070006': 1,
    'garbage-bags-38x50-jumbo-blk-sturdy-672663009258': 3,
    'mop-bucket-lucy-asstd-colours-5012075405043': 2,
    'garbage-bags-30x36-large-20pcs-blk-sturdy-672663009241': 1,
    'wopro-glyf-500ml-000001000207': 3,
    'wopro-glyf-1lt-000001000214': 2,
    'wopro-glyf-250ml-000001000191': 1,
    'silicone-100-clear-dap-070798086418': 3,
    'contact-cement-250ml-dunlop-047227898935': 2,
    'dap-painters-acrylic-latex-caulk-white-070798180659': 1,
    'angle-valve-1-2-fiptx3-8-comp-842851004260': 3,
    '3-4-sch40-90deg-elbow-406-007': 2,
    'bibcock-brass-1-2-x-3-4-5th-rough-842851003768': 1,
    'hex-key-set-13pc-1-3-10mm-660731105056': 3,
    'utility-knife-6-retractable-metal-660731431070': 2,
    'heat-gun-1500w-120v-60hz-6933528786412': 1
  };
  var instances = [];
  var cache = new Map();
  var instanceCounter = 0;

  function isPhase8() {
    return document.body &&
      document.body.getAttribute(PHASE_ATTRIBUTE) === PHASE_VALUE;
  }

  function clearNode(node) {
    while (node && node.firstChild) node.removeChild(node.firstChild);
  }

  function normalizedTerm(value) {
    return String(value || '').replace(/^\s+|\s+$/g, '').replace(/\s+/g, ' ');
  }

  function nativeRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = root || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function suggestionsUrl(term) {
    var params = new URLSearchParams();
    params.set('q', term);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', String(REQUEST_LIMIT));
    params.set('resources[limit_scope]', 'all');
    params.set('resources[options][unavailable_products]', 'last');
    params.set(
      'resources[options][fields]',
      'title,product_type,variants.title,vendor,variants.sku,variants.barcode'
    );
    return nativeRoot() + 'search/suggest.json?' + params.toString();
  }

  function fullSearchUrl(instance, term) {
    var url;
    try {
      url = new URL(instance.form.action || nativeRoot() + 'search', window.location.origin);
      url.searchParams.set('type', 'product');
      url.searchParams.set('q', term);
      url.searchParams.set('options[prefix]', 'last');
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return nativeRoot() + 'search?type=product&q=' + encodeURIComponent(term) +
        '&options%5Bprefix%5D=last';
    }
  }

  function ensurePrefixInput(form) {
    var prefix = form.querySelector('input[name="options[prefix]"]');
    if (!prefix) {
      prefix = document.createElement('input');
      prefix.type = 'hidden';
      prefix.name = 'options[prefix]';
      form.appendChild(prefix);
    }
    prefix.value = 'last';
  }

  function isShipSketchProduct(product) {
    var id = String(product && product.id || '');
    var handle = String(product && product.handle || '').toLowerCase();
    var url = String(product && product.url || '').split('?')[0].replace(/\/$/, '').toLowerCase();
    return id.indexOf(SHIPSKETCH_PRODUCT_ID) !== -1 ||
      handle === SHIPSKETCH_HANDLE ||
      url.slice(-('/products/' + SHIPSKETCH_HANDLE).length) === '/products/' + SHIPSKETCH_HANDLE;
  }

  function productImage(product) {
    if (!product) return '';
    if (typeof product.image === 'string') return product.image;
    if (product.image && typeof product.image.url === 'string') return product.image.url;
    if (product.featured_image && typeof product.featured_image.url === 'string') {
      return product.featured_image.url;
    }
    return '';
  }

  function foldSearchText(value) {
    var text = String(value || '').toLowerCase();
    if (text.normalize) text = text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    return text.replace(/[^a-z0-9]+/g, ' ').replace(/^\s+|\s+$/g, '').replace(/\s+/g, ' ');
  }

  function compactCode(value) {
    return foldSearchText(value).replace(/\s+/g, '');
  }

  function uniqueValues(values) {
    var seen = Object.create(null);
    return values.filter(function (value) {
      var key = compactCode(value);
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function productCodes(product) {
    var codes = [];
    var title = String(product && product.title || '');
    var handle = String(product && product.handle || '');
    var titleParts = title.split(/\s+-\s+/);
    var handleParts = handle.split('-');

    (product && product.variants || []).forEach(function (variant) {
      if (variant && variant.sku) codes.push(variant.sku);
      if (variant && variant.barcode) codes.push(variant.barcode);
    });

    if (titleParts.length > 1 && /\d/.test(titleParts[titleParts.length - 1])) {
      codes.push(titleParts[titleParts.length - 1]);
    }
    if (handleParts.length && /\d/.test(handleParts[handleParts.length - 1])) {
      codes.push(handleParts[handleParts.length - 1]);
    }
    return uniqueValues(codes);
  }

  function phraseIsWhole(text, phrase) {
    return (' ' + text + ' ').indexOf(' ' + phrase + ' ') !== -1;
  }

  function wordPrefixDistance(words, queryWords) {
    var distance = 0;
    var used = Object.create(null);
    var matched = queryWords.every(function (queryWord) {
      var bestIndex = -1;
      var bestDistance = Infinity;

      words.forEach(function (word, index) {
        var candidateDistance;
        if (used[index] || word.indexOf(queryWord) !== 0) return;
        candidateDistance = word.length - queryWord.length;
        if (candidateDistance < bestDistance) {
          bestDistance = candidateDistance;
          bestIndex = index;
        }
      });

      if (bestIndex < 0) return false;
      used[bestIndex] = true;
      distance += bestDistance;
      return true;
    });

    return matched ? distance : -1;
  }

  function relevanceScore(term, record) {
    var query = foldSearchText(term);
    var queryWords = query ? query.split(' ') : [];
    var title = foldSearchText(record && record.title);
    var secondary = foldSearchText(record && record.secondary);
    var titleWords = title ? title.split(' ') : [];
    var secondaryWords = secondary ? secondary.split(' ') : [];
    var queryCode = compactCode(term);
    var prefixDistance;
    var score = 0;

    if (!query || !title) return score;

    if ((record.codes || []).some(function (code) {
      return compactCode(code) === queryCode;
    })) {
      score = 100000;
    } else if (title === query) {
      score = 90000;
    } else if (phraseIsWhole(title, query)) {
      score = 85000;
    } else if (queryWords.every(function (word) { return titleWords.indexOf(word) !== -1; })) {
      score = 84000;
    } else if (title.indexOf(query) === 0) {
      prefixDistance = wordPrefixDistance(titleWords, queryWords);
      score = 77000 - Math.max(prefixDistance, 0);
    } else {
      prefixDistance = wordPrefixDistance(titleWords, queryWords);
      if (prefixDistance >= 0) {
        score = 69000 - Math.min(prefixDistance, 500);
      } else if (phraseIsWhole(secondary, query)) {
        score = 56000;
      } else if (queryWords.every(function (word) { return secondaryWords.indexOf(word) !== -1; })) {
        score = 52000;
      } else {
        prefixDistance = wordPrefixDistance(secondaryWords, queryWords);
        if (prefixDistance >= 0) score = 46000 - Math.min(prefixDistance, 500);
      }
    }

    /* Availability is deliberately only a tie-break-sized boost. Shopify's
     * original response order remains the final popularity/relevance signal. */
    if (score > 0 && record.available !== false) score += 0.1;
    return score;
  }

  function rankProducts(term, products) {
    return products.map(function (product, index) {
      return {
        index: index,
        product: product,
        popularity: 0,
        score: relevanceScore(term, {
          title: product && product.title,
          secondary: [
            product && product.body,
            product && product.vendor,
            product && product.type
          ].filter(Boolean).join(' '),
          codes: productCodes(product),
          available: product && product.available
        })
      };
    }).map(function (entry) {
      if (entry.score > 0) {
        entry.popularity = POPULARITY_BY_HANDLE[
          String(entry.product && entry.product.handle || '').toLowerCase()
        ] || 0;
      }
      return entry;
    }).sort(function (left, right) {
      return right.score - left.score ||
        right.popularity - left.popularity ||
        left.index - right.index;
    }).map(function (entry) {
      return entry.product;
    });
  }

  function productHandle(product) {
    var match;
    if (product && product.handle) return String(product.handle).toLowerCase();
    match = String(product && product.url || '').match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function predictiveOrder(term, signal) {
    var key = normalizedTerm(term).toLowerCase();
    var fromProducts = function (products) {
      return rankProducts(term, products.filter(function (product) {
        return !isShipSketchProduct(product);
      })).map(productHandle).filter(Boolean);
    };

    if (cache.has(key)) return Promise.resolve(fromProducts(cache.get(key)));
    return fetch(suggestionsUrl(term), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Predictive order request failed: ' + response.status);
      return response.json();
    }).then(function (data) {
      var products = data && data.resources && data.resources.results &&
        data.resources.results.products || [];
      remember(key, products);
      return fromProducts(products);
    });
  }

  window.KjsPhase8SearchRanking = {
    fold: foldSearchText,
    compactCode: compactCode,
    score: relevanceScore,
    popularity: function (handle) {
      return POPULARITY_BY_HANDLE[String(handle || '').toLowerCase()] || 0;
    }
  };
  window.KjsPhase8PredictiveOrder = predictiveOrder;

  function activeCurrency() {
    return window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'BBD';
  }

  function formatMoney(cents) {
    var value = Number(cents);
    var currency = activeCurrency();
    if (!isFinite(value)) return '';

    if (currency === 'BBD') return 'BBD $' + value.toFixed(2);

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-BB', {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'code',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return currency + ' $' + value.toFixed(2);
    }
  }

  function setStatus(instance, message) {
    instance.status.textContent = message || '';
  }

  function options(instance) {
    return Array.prototype.slice.call(
      instance.list.querySelectorAll('a.kjs-native-autocomplete__option[href]')
    );
  }

  function setActive(instance, index) {
    var items = options(instance);
    var next = index;
    var itemIndex;

    if (!items.length) {
      instance.activeIndex = -1;
      instance.input.removeAttribute('aria-activedescendant');
      return;
    }

    if (next < 0) next = items.length - 1;
    if (next >= items.length) next = 0;
    instance.activeIndex = next;

    for (itemIndex = 0; itemIndex < items.length; itemIndex += 1) {
      items[itemIndex].classList.toggle('is-active', itemIndex === next);
      items[itemIndex].setAttribute('aria-selected', itemIndex === next ? 'true' : 'false');
    }

    instance.input.setAttribute('aria-activedescendant', items[next].id);
    if (typeof items[next].scrollIntoView === 'function') {
      items[next].scrollIntoView({ block: 'nearest' });
    }
  }

  function close(instance) {
    if (!instance) return;
    instance.list.style.display = 'none';
    instance.list.hidden = true;
    instance.input.setAttribute('aria-expanded', 'false');
    instance.input.removeAttribute('aria-activedescendant');
    instance.activeIndex = -1;
    options(instance).forEach(function (option) {
      option.classList.remove('is-active');
      option.setAttribute('aria-selected', 'false');
    });
  }

  function closeOthers(current) {
    instances.forEach(function (instance) {
      if (instance !== current) close(instance);
    });
  }

  function open(instance) {
    closeOthers(instance);
    instance.list.hidden = false;
    instance.list.style.display = 'block';
    instance.input.setAttribute('aria-expanded', 'true');
  }

  function makeProductOption(instance, product, index) {
    var row = document.createElement('li');
    var link = document.createElement('a');
    var imageWrap = document.createElement('span');
    var imageUrl = productImage(product);
    var text = document.createElement('span');
    var title = document.createElement('span');
    var price = document.createElement('span');
    var image;

    row.className = 'kjs-native-autocomplete__item';
    row.setAttribute('role', 'presentation');

    link.className = 'kjs-native-autocomplete__option';
    link.href = product.url;
    link.id = instance.list.id + '-option-' + index;
    link.setAttribute('role', 'option');
    link.setAttribute('aria-selected', 'false');
    link.setAttribute('tabindex', '-1');

    imageWrap.className = 'kjs-native-autocomplete__image';
    if (imageUrl) {
      image = document.createElement('img');
      image.src = imageUrl;
      image.alt = '';
      image.width = 52;
      image.height = 52;
      image.loading = 'lazy';
      image.decoding = 'async';
      imageWrap.appendChild(image);
    } else {
      imageWrap.classList.add('is-empty');
      imageWrap.setAttribute('aria-hidden', 'true');
    }

    text.className = 'kjs-native-autocomplete__text';
    title.className = 'kjs-native-autocomplete__title';
    title.textContent = product.title || 'Product';
    text.appendChild(title);

    price.className = 'kjs-native-autocomplete__price';
    if (window.KjsStockContact && window.KjsStockContact.enabled && product.available === false) {
      price.classList.add('is-contact');
      price.textContent = window.KjsStockContact.message + ' ' + window.KjsStockContact.phone;
    } else {
      price.textContent = formatMoney(product.price);
    }
    if (price.textContent) text.appendChild(price);

    link.appendChild(imageWrap);
    link.appendChild(text);
    row.appendChild(link);
    return row;
  }

  function makeViewAllOption(instance, term, index) {
    var row = document.createElement('li');
    var link = document.createElement('a');
    var arrow = document.createElement('span');

    row.className = 'kjs-native-autocomplete__all-item';
    row.setAttribute('role', 'presentation');
    link.className = 'kjs-native-autocomplete__option kjs-native-autocomplete__all';
    link.href = fullSearchUrl(instance, term);
    link.id = instance.list.id + '-option-' + index;
    link.setAttribute('role', 'option');
    link.setAttribute('aria-selected', 'false');
    link.setAttribute('tabindex', '-1');
    link.appendChild(document.createTextNode('View all results for \u201c' + term + '\u201d'));
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '\u2192';
    link.appendChild(arrow);
    row.appendChild(link);
    return row;
  }

  function render(instance, term, products) {
    var heading;
    var itemIndex;
    var filtered = rankProducts(term, products.filter(function (product) {
      return !isShipSketchProduct(product);
    })).slice(0, RESULT_LIMIT);

    if (normalizedTerm(instance.input.value).toLowerCase() !== term.toLowerCase()) return;

    clearNode(instance.list);
    instance.activeIndex = -1;

    if (!filtered.length) {
      close(instance);
      setStatus(instance, 'No product suggestions. Press Enter to search.');
      return;
    }

    heading = document.createElement('li');
    heading.className = 'kjs-native-autocomplete__heading';
    heading.setAttribute('role', 'presentation');
    heading.textContent = 'Product suggestions';
    instance.list.appendChild(heading);

    for (itemIndex = 0; itemIndex < filtered.length; itemIndex += 1) {
      instance.list.appendChild(makeProductOption(instance, filtered[itemIndex], itemIndex));
    }
    instance.list.appendChild(makeViewAllOption(instance, term, filtered.length));

    open(instance);
    setStatus(
      instance,
      filtered.length + (filtered.length === 1 ? ' product suggestion available.' : ' product suggestions available.')
    );
  }

  function remember(term, products) {
    if (cache.has(term)) cache.delete(term);
    cache.set(term, products);
    if (cache.size > CACHE_LIMIT) cache.delete(cache.keys().next().value);
  }

  function requestSuggestions(instance, term) {
    var cacheKey = term.toLowerCase();
    var requestSequence;

    if (cache.has(cacheKey)) {
      render(instance, term, cache.get(cacheKey));
      return;
    }

    if (instance.controller && typeof instance.controller.abort === 'function') {
      instance.controller.abort();
    }
    instance.controller = 'AbortController' in window ? new AbortController() : null;
    requestSequence = ++instance.requestSequence;
    setStatus(instance, 'Loading product suggestions.');

    fetch(suggestionsUrl(term), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: instance.controller ? instance.controller.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Predictive search request failed: ' + response.status);
        return response.json();
      })
      .then(function (data) {
        var products;
        if (requestSequence !== instance.requestSequence) return;
        products = data && data.resources && data.resources.results && data.resources.results.products || [];
        remember(cacheKey, products);
        render(instance, term, products);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (requestSequence !== instance.requestSequence) return;
        close(instance);
        setStatus(instance, 'Product suggestions are unavailable. Press Enter to search.');
      });
  }

  function queueSuggestions(instance) {
    var term = normalizedTerm(instance.input.value);
    window.clearTimeout(instance.timer);
    instance.input.setAttribute('data-old-term', instance.input.value);

    if (term.length < MIN_CHARACTERS) {
      if (instance.controller && typeof instance.controller.abort === 'function') instance.controller.abort();
      close(instance);
      clearNode(instance.list);
      setStatus(instance, '');
      return;
    }

    closeOthers(instance);
    instance.timer = window.setTimeout(function () {
      requestSuggestions(instance, term);
    }, DEBOUNCE_DELAY);
  }

  function markLegacyTerm(event) {
    event.currentTarget.setAttribute('data-old-term', event.currentTarget.value);
  }

  function handleKeydown(instance, event) {
    var items = options(instance);
    var key = event.key;

    if ((key === 'ArrowDown' || key === 'ArrowUp') && !instance.list.hidden && items.length) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setActive(instance, instance.activeIndex + (key === 'ArrowDown' ? 1 : -1));
      return;
    }

    if ((key === 'Home' || key === 'End') && !instance.list.hidden && items.length) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setActive(instance, key === 'Home' ? 0 : items.length - 1);
      return;
    }

    if (key === 'Enter' && !instance.list.hidden && instance.activeIndex >= 0 && items[instance.activeIndex]) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(items[instance.activeIndex].href);
      return;
    }

    if (key === 'Escape') {
      if (!instance.list.hidden) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      close(instance);
      return;
    }

    if (key === 'Tab') close(instance);
  }

  function ensureList(form, input, suffix) {
    var list = form.querySelector('.search_autocomplete_wrapper');
    if (!list) {
      list = document.createElement('ul');
      list.className = 'search-results search_autocomplete_wrapper';
      form.appendChild(list);
    }

    list.classList.add('kjs-native-autocomplete');
    list.id = list.id || 'KjsNativeSuggestions' + suffix;
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', 'Product suggestions');
    list.hidden = true;
    list.style.display = 'none';

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-controls', list.id);
    input.setAttribute('aria-owns', list.id);
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');
    return list;
  }

  function bindForm(form) {
    var input;
    var suffix;
    var list;
    var status;
    var instance;

    if (!form || form.getAttribute('data-kjs-native-autocomplete') === 'true') return;
    input = form.querySelector('input[type="search"][name="q"], input[name="q"]');
    if (!input) return;

    form.setAttribute('data-kjs-native-autocomplete', 'true');
    suffix = String(++instanceCounter);
    list = ensureList(form, input, suffix);
    status = document.createElement('div');
    status.className = 'kjs-native-autocomplete__status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    form.appendChild(status);
    ensurePrefixInput(form);

    instance = {
      form: form,
      input: input,
      list: list,
      status: status,
      timer: null,
      controller: null,
      requestSequence: 0,
      activeIndex: -1
    };
    instances.push(instance);

    input.addEventListener('input', function () { queueSuggestions(instance); });
    input.addEventListener('search', function () { queueSuggestions(instance); });
    input.addEventListener('keyup', markLegacyTerm, true);
    input.addEventListener('change', markLegacyTerm, true);
    input.addEventListener('keydown', function (event) { handleKeydown(instance, event); }, true);
    input.addEventListener('focus', function () {
      var term = normalizedTerm(input.value);
      closeOthers(instance);
      if (term.length >= MIN_CHARACTERS && cache.has(term.toLowerCase())) {
        render(instance, term, cache.get(term.toLowerCase()));
      }
    });

    list.addEventListener('mousemove', function (event) {
      var option = event.target.closest && event.target.closest('a.kjs-native-autocomplete__option');
      var itemIndex = options(instance).indexOf(option);
      if (itemIndex >= 0 && itemIndex !== instance.activeIndex) setActive(instance, itemIndex);
    });
  }

  function initialize() {
    var forms;
    if (!isPhase8()) return;
    forms = document.querySelectorAll('[data-kjs-search-dock] form[action*="/search"]');
    Array.prototype.forEach.call(forms, bindForm);
  }

  document.addEventListener('click', function (event) {
    instances.forEach(function (instance) {
      if (!instance.form.contains(event.target)) close(instance);
    });
  }, true);

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) instances.forEach(close);
  });

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(initialize, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.requestAnimationFrame(initialize);
      window.setTimeout(initialize, 500);
    });
  } else {
    window.requestAnimationFrame(initialize);
    window.setTimeout(initialize, 500);
  }
}());

/*
 * Phase 8 search-results ordering.
 *
 * Shopify's regular search can favour typo-tolerant matches for short terms
 * (for example, "bic" can rank "bib" ahead of "bicycle"). Keep the native
 * fuzzy results as a fail-open fallback, then request an explicit prefix view
 * and place those unique products first.
 */
(function () {
  'use strict';

  var PHASE_ATTRIBUTE = 'data-kjs-card-phase';
  var PHASE_VALUE = '8';
  var PREFIX_VIEW = 'kjs-prefix';
  var PREFIX_MIN_CHARACTERS = 3;
  var PREFIX_REQUEST_TIMEOUT = 8000;
  var FUZZY_GATE_MAX_ATTEMPTS = 220;
  var SHIPSKETCH_HANDLE = 'delivery-location';
  var predictiveRanks = Object.create(null);
  var initialized = false;

  function isPhase8Search() {
    return document.body &&
      document.body.getAttribute(PHASE_ATTRIBUTE) === PHASE_VALUE &&
      document.body.classList.contains('template-search');
  }

  function normalizedTerm(value) {
    return String(value || '').replace(/^\s+|\s+$/g, '').replace(/\s+/g, ' ');
  }

  function exactCodeQuery(term) {
    var ranking = window.KjsPhase8SearchRanking;
    var normalized = normalizedTerm(term);
    var folded;
    var forms;
    var seen = Object.create(null);
    var clauses = [];

    if (!ranking || !/\d/.test(normalized) ||
        !/^[a-z0-9._\/\-\s]+$/i.test(normalized)) return '';

    folded = ranking.fold(normalized);
    forms = [
      normalized.toLowerCase().replace(/\s+/g, ''),
      ranking.compactCode(normalized),
      folded.replace(/\s+/g, '-'),
      folded.replace(/([a-z])(?=\d)/gi, '$1-').replace(/(\d)(?=[a-z])/gi, '$1-')
    ];

    forms.forEach(function (form) {
      form = form.replace(/[^a-z0-9._\/-]+/gi, '');
      if (form.length < PREFIX_MIN_CHARACTERS || seen[form]) return;
      seen[form] = true;
      clauses.push('variants.sku:' + form);
      clauses.push('variants.barcode:' + form);
    });
    return clauses.length ? '(' + clauses.join(' OR ') + ')' : '';
  }

  function prefixQuery(term) {
    var words;
    var last;
    var wildcard;
    var scopedPrefix;
    var codeQuery;

    term = normalizedTerm(term);
    if (!term || /[*":()]/.test(term) || /\b(?:AND|OR|NOT)\b/i.test(term)) return '';
    codeQuery = exactCodeQuery(term);

    /* Folding punctuation also lets common code forms such as FW-010 and
     * FW 010 enter the same prefix path; the shared ranker still prefers an
     * exact compact SKU/barcode match. */
    words = (window.KjsPhase8SearchRanking &&
      window.KjsPhase8SearchRanking.fold(term) || term).split(' ');
    last = words[words.length - 1];
    if (last.length < PREFIX_MIN_CHARACTERS || !/^[a-z0-9]+$/i.test(last)) {
      return codeQuery;
    }

    wildcard = last + '*';
    scopedPrefix = '(' + [
      'title:' + wildcard,
      'vendor:' + wildcard,
      'product_type:' + wildcard,
      'variants.sku:' + wildcard,
      'variants.barcode:' + wildcard
    ].join(' OR ') + ')';
    words.pop();
    scopedPrefix = words.length ? '(' + words.join(' ') + ' ' + scopedPrefix + ')' : scopedPrefix;
    return codeQuery ? '(' + codeQuery + ' OR ' + scopedPrefix + ')' : scopedPrefix;
  }

  function priorityQuery(term) {
    var ranking = window.KjsPhase8SearchRanking;
    var normalized = normalizedTerm(term);
    var codeQuery = exactCodeQuery(normalized);
    var words;
    var titleQuery;

    if (!normalized || /[*\":()]/.test(normalized) || /\b(?:AND|OR|NOT)\b/i.test(normalized)) {
      return codeQuery;
    }

    words = (ranking && ranking.fold(normalized) || normalized.toLowerCase()).split(' ')
      .filter(function (word) { return /^[a-z0-9]+$/i.test(word); });
    if (!words.length || words[words.length - 1].length < PREFIX_MIN_CHARACTERS) {
      return codeQuery;
    }

    /* Shopify can treat an unstarred title filter containing an item code as
     * an empty filter, which exposes the whole catalogue as direct matches.
     * Keep compact codes (TCC57, FW-010, 7450014001792) and equivalent split
     * forms (FW 010) scoped to SKU/barcode. The separate wildcard prefix
     * request safely finds codes that are appended to product titles. */
    if (codeQuery && (
      !/\s/.test(normalized) ||
      /^[a-z]+\s+\d+$/i.test(normalized) ||
      /^\d+\s+[a-z]+$/i.test(normalized)
    )) {
      return codeQuery;
    }

    /* Shopify's unstarred title terms match complete tokens (including its
     * normal plural handling) but do not promote broader prefixes such as
     * "mattress" for "mat". Fetch this tier first so complete-word title and
     * exact code matches are exhausted before the wider prefix result set. */
    titleQuery = words.map(function (word) { return 'title:' + word; }).join(' AND ');
    if (words.length > 1) titleQuery = '(' + titleQuery + ')';
    return codeQuery ? '(' + codeQuery + ' OR ' + titleQuery + ')' : titleQuery;
  }

  window.KjsPhase8SearchPrefixQuery = prefixQuery;
  window.KjsPhase8SearchExactCodeQuery = exactCodeQuery;
  window.KjsPhase8SearchPriorityQuery = priorityQuery;

  function cardHandle(card) {
    var link;
    var url;
    var match;

    if (!card || !card.querySelector) return '';
    link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';

    try {
      url = new URL(link.getAttribute('href'), window.location.origin);
      match = url.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]).toLowerCase() : '';
    } catch (error) {
      return '';
    }
  }

  function directCards(grid) {
    return Array.prototype.filter.call(grid && grid.children || [], function (child) {
      return child.nodeType === 1 && cardHandle(child);
    });
  }

  function safeDecode(value) {
    try {
      return decodeURIComponent(String(value || '').replace(/\+/g, ' '));
    } catch (error) {
      return String(value || '');
    }
  }

  function cardCodes(card) {
    var codes = [];
    var encoded = String(card.getAttribute('data-kjs-search-codes') || '');
    var sku = card.querySelector('.kjs-card-sku');

    encoded.split('|').forEach(function (pair) {
      pair.split('~').forEach(function (code) {
        code = safeDecode(code);
        if (code) codes.push(code);
      });
    });
    if (sku && sku.textContent.trim()) codes.push(sku.textContent.trim());
    return codes;
  }

  function cardRecord(card) {
    var title = card.querySelector('.kjs-card-title');
    var handle = card.getAttribute('data-kjs-search-handle') || cardHandle(card);
    var soldOut = card.querySelector('.kjs-card-availability.is-sold-out');
    return {
      title: card.getAttribute('data-kjs-search-title') || title && title.textContent || '',
      secondary: card.getAttribute('data-kjs-search-secondary') || '',
      codes: cardCodes(card),
      available: card.getAttribute('data-kjs-search-available') ?
        card.getAttribute('data-kjs-search-available') === 'true' : !soldOut,
      handle: handle
    };
  }

  function customerSelectedSort() {
    var value = new URLSearchParams(window.location.search).get('sort_by');
    return Boolean(value && value !== 'relevance');
  }

  function rankedCards(grid, term) {
    var ranking = window.KjsPhase8SearchRanking;
    var cards = directCards(grid);
    if (!ranking || customerSelectedSort()) return cards;

    return cards.map(function (card, index) {
      var record = cardRecord(card);
      return {
        card: card,
        index: index,
        handle: record.handle,
        predictiveRank: Object.prototype.hasOwnProperty.call(predictiveRanks, record.handle) ?
          predictiveRanks[record.handle] : Infinity,
        popularity: 0,
        score: ranking.score(term, record)
      };
    }).map(function (entry) {
      if (entry.score > 0) entry.popularity = ranking.popularity(entry.handle);
      return entry;
    }).sort(function (left, right) {
      return right.score - left.score ||
        left.predictiveRank - right.predictiveRank ||
        right.popularity - left.popularity ||
        left.index - right.index;
    }).map(function (entry) {
      return entry.card;
    });
  }

  function rankGridInPlace(grid, term) {
    rankedCards(grid, term).forEach(function (card) {
      grid.appendChild(card);
    });
  }

  function fuzzyWaypoint(page) {
    var grid = page && page.querySelector('.kjs-search-results-panel .search-infinite-wrapper');
    var context;
    var vertical;
    var found = null;

    if (!grid || !window.Waypoint || !window.Waypoint.Context) return null;
    context = window.Waypoint.Context.findByElement(window);
    vertical = context && context.waypoints && context.waypoints.vertical;
    if (!vertical) return null;

    Object.keys(vertical).some(function (key) {
      if (vertical[key] && vertical[key].element === grid) {
        found = vertical[key];
        return true;
      }
      return false;
    });
    return found;
  }

  function createFuzzyLoaderGate(page) {
    var catalogElement = page &&
      page.querySelector('.kjs-search-results-panel .search-infinite-wrapper');
    var gate = {
      page: page,
      catalogElement: catalogElement,
      catalogPaused: false,
      waypoint: null,
      released: false,
      attempts: 0,
      timer: null
    };

    gate.pause = function () {
      var waypoint;
      var catalogAutoload;
      if (gate.released) return;
      catalogAutoload = window.KjsCatalogAutoload;
      if (catalogAutoload &&
          typeof catalogAutoload.pauseForElement === 'function' &&
          catalogAutoload.pauseForElement(gate.catalogElement)) {
        gate.catalogPaused = true;
        return;
      }
      waypoint = fuzzyWaypoint(gate.page);
      gate.attempts += 1;
      if (waypoint) {
        gate.waypoint = waypoint;
        waypoint.disable();
        return;
      }
      if (!gate.released && gate.attempts < FUZZY_GATE_MAX_ATTEMPTS) {
        gate.timer = window.setTimeout(gate.pause, 50);
      }
    };

    gate.resume = function () {
      var catalogAutoload = window.KjsCatalogAutoload;
      gate.released = true;
      window.clearTimeout(gate.timer);
      if (catalogAutoload && typeof catalogAutoload.resumeForElement === 'function') {
        catalogAutoload.resumeForElement(gate.catalogElement);
      }
      if (!gate.waypoint) gate.waypoint = fuzzyWaypoint(gate.page);
      if (gate.waypoint) gate.waypoint.enable();
      if (window.Waypoint && typeof window.Waypoint.refreshAll === 'function') {
        window.Waypoint.refreshAll();
      }
    };

    gate.pause();
    return gate;
  }

  function prefixFragmentUrl(query) {
    var url = new URL(window.location.href);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('view', PREFIX_VIEW);
    url.searchParams.delete('page');
    return url.toString();
  }

  function safeNextUrl(href) {
    var url;
    if (!href) return '';

    try {
      url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return '';
      url.searchParams.set('view', PREFIX_VIEW);
      url.searchParams.set('type', 'product');
      return url.toString();
    } catch (error) {
      return '';
    }
  }

  function fetchFragment(url, signal) {
    return fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
      signal: signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Prefix search request failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fragment = parsed.querySelector('[data-kjs-prefix-results]');
        if (!fragment) throw new Error('Prefix search fragment was not returned.');
        return fragment;
      });
  }

  function fetchFragmentWithTimeout(url, parentSignal) {
    var controller = 'AbortController' in window ? new AbortController() : null;
    var timedOut = false;
    var timer;
    var parentAbort;

    if (!controller) return fetchFragment(url, parentSignal);

    parentAbort = function () { controller.abort(); };
    if (parentSignal) {
      if (parentSignal.aborted) controller.abort();
      else parentSignal.addEventListener('abort', parentAbort, { once: true });
    }
    timer = window.setTimeout(function () {
      timedOut = true;
      controller.abort();
    }, PREFIX_REQUEST_TIMEOUT);

    function cleanup() {
      window.clearTimeout(timer);
      if (parentSignal) parentSignal.removeEventListener('abort', parentAbort);
    }

    return fetchFragment(url, controller.signal).then(function (fragment) {
      cleanup();
      return fragment;
    }).catch(function (error) {
      var timeoutError;
      cleanup();
      if (!timedOut) throw error;
      timeoutError = new Error('Matching products took too long to load.');
      timeoutError.name = 'TimeoutError';
      throw timeoutError;
    });
  }

  function tierHeader(id, title, description) {
    var header = document.createElement('header');
    var heading = document.createElement('h2');
    var copy = document.createElement('p');

    header.className = 'kjs-search-tier__header';
    heading.id = id;
    heading.textContent = title;
    copy.className = 'kjs-search-tier__description';
    copy.textContent = description;
    header.appendChild(heading);
    header.appendChild(copy);
    return header;
  }

  function prefixFacetData(fragment) {
    var values = Object.create(null);
    Array.prototype.forEach.call(fragment.querySelectorAll('[data-kjs-prefix-facet]'), function (facet) {
      var param = facet.getAttribute('data-param-name') || '';
      var value = facet.getAttribute('data-value') || '';
      if (!param) return;
      values[param + '\u0000' + value] = {
        count: Number(facet.getAttribute('data-count') || 0),
        active: facet.getAttribute('data-active') === 'true'
      };
    });
    return values;
  }

  function prefixPriceRangeMax(fragment) {
    var range = fragment.querySelector('[data-kjs-prefix-price-range]');
    var value = range && range.getAttribute('data-range-max');
    return value && Number(value) >= 0 ? value : '';
  }

  function buildState(page, term, fragment, loaderGate) {
    var resultsPanel = page.querySelector('.kjs-search-results-panel');
    var fuzzyContainer = resultsPanel && resultsPanel.querySelector('.product_c');
    var fuzzyGrid = fuzzyContainer && fuzzyContainer.querySelector('.search-infinite-wrapper');
    var parent = resultsPanel || page;
    var reference = fuzzyContainer || page.querySelector('.kjs-search-quicklinks') || null;
    var prefixSection = document.createElement('section');
    var prefixProductContainer = document.createElement('div');
    var prefixRow = document.createElement('div');
    var prefixGrid = document.createElement('div');
    var sentinel = document.createElement('div');
    var loadMore = document.createElement('button');
    var status = document.createElement('p');
    var fuzzySection = null;
    var fuzzyHandles = new Map();

    prefixSection.className = 'kjs-search-tier kjs-search-tier--matching';
    prefixSection.setAttribute('aria-labelledby', 'KjsMatchingProductsTitle');
    prefixSection.appendChild(tierHeader(
      'KjsMatchingProductsTitle',
      'Matching products',
      String(fragment.getAttribute('data-kjs-prefix-count') || '0') +
        ' direct matches for “' + term + '”.'
    ));

    prefixProductContainer.className = 'product_c kjs-search-tier__products';
    prefixRow.className = 'row';
    prefixGrid.className = 'kjs-prefix-grid';
    prefixGrid.setAttribute('data-kjs-prefix-live-grid', '');
    prefixRow.appendChild(prefixGrid);
    prefixProductContainer.appendChild(prefixRow);
    prefixSection.appendChild(prefixProductContainer);

    sentinel.className = 'kjs-prefix-autoload-sentinel';
    sentinel.setAttribute('data-kjs-prefix-autoload-sentinel', '');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.hidden = true;
    prefixSection.appendChild(sentinel);

    loadMore.type = 'button';
    loadMore.className = 'kjs-prefix-load-more';
    loadMore.textContent = 'Show more matching products';
    loadMore.hidden = true;
    prefixSection.appendChild(loadMore);

    status.className = 'kjs-prefix-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    prefixSection.appendChild(status);

    parent.insertBefore(prefixSection, reference);

    if (fuzzyGrid && fuzzyContainer) {
      rankGridInPlace(fuzzyGrid, term);
      directCards(fuzzyGrid).forEach(function (card) {
        fuzzyHandles.set(cardHandle(card), card);
      });

      fuzzySection = document.createElement('section');
      fuzzySection.className = 'kjs-search-tier kjs-search-tier--similar';
      fuzzySection.setAttribute('aria-labelledby', 'KjsSimilarProductsTitle');
      fuzzySection.appendChild(tierHeader(
        'KjsSimilarProductsTitle',
        'Similar matches',
        'Other relevant products, including close spellings.'
      ));
      parent.insertBefore(fuzzySection, fuzzyContainer);
      fuzzySection.appendChild(fuzzyContainer);
    }

    return {
      term: term,
      page: page,
      prefixSection: prefixSection,
      prefixGrid: prefixGrid,
      prefixHandles: new Map(),
      fuzzySection: fuzzySection,
      fuzzyContainer: fuzzyContainer,
      fuzzyGrid: fuzzyGrid,
      fuzzyHandles: fuzzyHandles,
      sentinel: sentinel,
      loadMore: loadMore,
      status: status,
      nextUrl: '',
      priorityLoading: false,
      pendingBroadFragment: null,
      loading: false,
      autoLoadSupported: 'IntersectionObserver' in window,
      autoLoadFailed: false,
      autoLoadObserver: null,
      autoLoadObserveQueued: false,
      controller: 'AbortController' in window ? new AbortController() : null,
      total: Number(fragment.getAttribute('data-kjs-prefix-count') || 0),
      facets: prefixFacetData(fragment),
      priceRangeMax: prefixPriceRangeMax(fragment),
      loaderGate: loaderGate
    };
  }

  function restoreNativeResults(state) {
    if (state.autoLoadObserver) state.autoLoadObserver.disconnect();
    if (state.fuzzySection && state.fuzzyContainer && state.fuzzySection.parentNode) {
      state.fuzzySection.parentNode.insertBefore(state.fuzzyContainer, state.fuzzySection);
      state.fuzzySection.remove();
    }
    if (state.prefixSection) state.prefixSection.remove();
    if (state.loaderGate) state.loaderGate.resume();
  }

  function updateBreadcrumbCount(state) {
    var breadcrumb = state.page.querySelector('.breadcrumb, .breadcrumbs');
    var current;
    if (!breadcrumb) return;
    current = breadcrumb.querySelector('.active, [aria-current="page"]') || breadcrumb.lastElementChild;
    if (!current) return;
    current.textContent = state.total +
      (state.total === 1 ? ' direct match' : ' direct matches') +
      ' for “' + state.term + '”';
  }

  function updateAvailabilityCounts(state) {
    var inputs = state.page.querySelectorAll(
      '.kjs-search-filter-form input[name="filter.v.availability"]'
    );

    Array.prototype.forEach.call(inputs, function (input) {
      var metadata = state.facets[
        input.getAttribute('name') + '\u0000' + input.getAttribute('value')
      ];
      var label = input.closest('label');
      var count = label && label.querySelector('.kjs-search-filter-count');

      if (!metadata) {
        input.disabled = false;
        if (count) {
          count.hidden = true;
          count.setAttribute('aria-hidden', 'true');
          count.setAttribute('data-kjs-prefix-count-stale', '');
        }
        return;
      }

      input.disabled = metadata.count === 0 && !input.checked;
      if (!count) return;
      count.hidden = false;
      count.removeAttribute('aria-hidden');
      count.removeAttribute('data-kjs-prefix-count-stale');
      count.textContent = '(' + metadata.count + ')';
      count.setAttribute(
        'aria-label',
        metadata.count + (metadata.count === 1 ? ' product' : ' products')
      );
    });
  }

  function addFilterScopeNote(state) {
    Array.prototype.forEach.call(
      state.page.querySelectorAll('.kjs-search-filter-form'),
      function (form) {
        var title;
        var note;
        if (form.querySelector('.kjs-search-filter-scope')) return;
        title = form.querySelector('.kjs-search-filter-form__title');
        note = document.createElement('p');
        note.className = 'kjs-search-filter-scope';
        note.textContent = 'Filters update all matching products.';
        if (title) title.insertAdjacentElement('afterend', note);
        else form.insertBefore(note, form.firstChild);
      }
    );
  }

  function updatePriceRange(state) {
    var inputs = state.page.querySelectorAll(
      '.kjs-search-filter-form input[type="number"][name*="filter.v.price"]'
    );
    Array.prototype.forEach.call(inputs, function (input) {
      if (state.priceRangeMax) input.setAttribute('max', state.priceRangeMax);
      else input.removeAttribute('max');

      if (/\.lte$/.test(input.getAttribute('name') || '') && !input.value) {
        if (state.priceRangeMax) input.setAttribute('placeholder', state.priceRangeMax);
        else input.removeAttribute('placeholder');
      }
    });
  }

  function updateResultContext(state) {
    var count = state.page.querySelector('.kjs-search-toolbar__count');
    if (count) {
      count.textContent = state.total +
        (state.total === 1 ? ' direct match' : ' direct matches');
    }
    updateBreadcrumbCount(state);
    updateAvailabilityCounts(state);
    updatePriceRange(state);
    addFilterScopeNote(state);
  }

  function updateNativeIntro(state) {
    var intro = state.page.querySelector('.kjs-search-page-intro');
    var heading;
    var help;
    var quicklinks;
    var support;
    var zeroState;

    updateResultContext(state);
    state.page.setAttribute('data-kjs-prefix-active', 'true');

    if (intro) {
      heading = intro.querySelector('h1');
      help = intro.querySelector('.kjs-search-page-intro__help');
      if (heading) heading.textContent = 'Search results for “' + state.term + '”';
      if (help) help.textContent = 'Direct matches are shown first. Filters and sorting apply within each group.';
      intro.classList.add('has-results', 'is-compact');

      quicklinks = state.page.querySelector('.kjs-search-quicklinks');
      support = state.page.querySelector('.kjs-search-support');
      zeroState = state.page.querySelector('.kjs-search-filter-zero');
      if (quicklinks) quicklinks.hidden = true;
      if (support) support.hidden = true;
      if (zeroState) zeroState.hidden = true;
    }

    zeroState = state.page.querySelector('.kjs-search-filter-zero');
    if (zeroState) zeroState.hidden = true;
  }

  function removeFuzzyDuplicate(state, handle) {
    var duplicate = state.fuzzyHandles.get(handle);
    if (!duplicate) return;
    duplicate.remove();
    state.fuzzyHandles.delete(handle);
  }

  function appendPrefixCards(state, fragment) {
    var sourceGrid = fragment.querySelector('[data-kjs-prefix-grid]');
    var added = 0;

    if (!sourceGrid) return added;
    rankedCards(sourceGrid, state.term).forEach(function (card) {
      var handle = cardHandle(card);
      var imported;

      if (!handle || handle === SHIPSKETCH_HANDLE || state.prefixHandles.has(handle)) return;
      imported = document.importNode(card, true);
      state.prefixHandles.set(handle, imported);
      removeFuzzyDuplicate(state, handle);
      state.prefixGrid.appendChild(imported);
      added += 1;
    });
    return added;
  }

  function fuzzyHasContent(state) {
    if (!state.fuzzyContainer) return false;
    return Boolean(
      directCards(state.fuzzyGrid).length ||
      state.fuzzyContainer.querySelector('.pagination, .kjs-pagination, .js-load-more')
    );
  }

  function observeFuzzyResults(state) {
    var observer;
    if (!state.fuzzyGrid || !('MutationObserver' in window)) return;

    observer = new MutationObserver(function () {
      var current;
      var ranked;
      directCards(state.fuzzyGrid).forEach(function (card) {
        var handle = cardHandle(card);
        if (!handle) return;
        if (state.prefixHandles.has(handle)) {
          card.remove();
          return;
        }
        state.fuzzyHandles.set(handle, card);
      });

      current = directCards(state.fuzzyGrid);
      ranked = rankedCards(state.fuzzyGrid, state.term);
      if (ranked.some(function (card, index) { return card !== current[index]; })) {
        ranked.forEach(function (card) { state.fuzzyGrid.appendChild(card); });
      }
      if (state.fuzzySection && !state.nextUrl) {
        state.fuzzySection.hidden = !fuzzyHasContent(state);
      }
    });

    observer.observe(state.fuzzyGrid, { childList: true });
    state.fuzzyObserver = observer;
  }

  function reconcileDirectCount(state) {
    var description = state.prefixSection.querySelector('.kjs-search-tier__description');

    state.total = state.prefixHandles.size;
    if (description) {
      description.textContent = state.total +
        (state.total === 1 ? ' direct match for “' : ' direct matches for “') +
        state.term + '”.';
    }
    updateResultContext(state);
  }

  function observeAutoLoadSentinel(state) {
    if (!state.autoLoadObserver || !state.nextUrl || state.loading || state.autoLoadFailed ||
        state.autoLoadObserveQueued) return;

    state.autoLoadObserveQueued = true;
    window.requestAnimationFrame(function () {
      state.autoLoadObserveQueued = false;
      if (!state.autoLoadObserver || !state.nextUrl || state.loading || state.autoLoadFailed) return;
      state.autoLoadObserver.observe(state.sentinel);
    });
  }

  function updateNext(state, fragment) {
    var next = fragment.querySelector('[data-kjs-prefix-next]');
    var added = 0;
    state.nextUrl = safeNextUrl(next && next.getAttribute('href'));

    /* Keep the broad-prefix first page detached until every complete-word
     * page has loaded. This gives later exact-word pages room to appear above
     * "mattress"-style matches without reordering cards the customer has
     * already seen. */
    if (!state.nextUrl && state.priorityLoading && state.pendingBroadFragment) {
      fragment = state.pendingBroadFragment;
      state.pendingBroadFragment = null;
      state.priorityLoading = false;
      added = appendPrefixCards(state, fragment);
      next = fragment.querySelector('[data-kjs-prefix-next]');
      state.nextUrl = safeNextUrl(next && next.getAttribute('href'));
    }

    if (state.nextUrl) {
      if (state.autoLoadSupported && !state.autoLoadFailed) {
        state.sentinel.hidden = false;
        state.loadMore.hidden = true;
        observeAutoLoadSentinel(state);
      } else {
        state.sentinel.hidden = true;
        state.loadMore.hidden = false;
        state.loadMore.disabled = false;
        state.loadMore.textContent = state.autoLoadFailed ?
          'Try loading matching products again' : 'Load more matching products';
      }
      if (state.fuzzySection) state.fuzzySection.hidden = true;
      return added;
    }

    state.sentinel.hidden = true;
    state.sentinel.classList.remove('is-loading');
    state.sentinel.textContent = '';
    state.loadMore.hidden = true;
    state.loadMore.disabled = false;
    if (state.autoLoadObserver) state.autoLoadObserver.disconnect();
    reconcileDirectCount(state);
    if (state.fuzzySection) state.fuzzySection.hidden = !fuzzyHasContent(state);
    if (state.loaderGate) state.loaderGate.resume();
    return added;
  }

  function setAutoLoadIndicator(state, loading) {
    state.sentinel.classList.toggle('is-loading', loading);
    state.sentinel.textContent = loading ? 'Loading more matching products…' : '';
    state.prefixSection.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function loadNextPage(state) {
    var requestUrl = state.nextUrl;
    if (!requestUrl || state.loading) return;

    if (state.autoLoadObserver) state.autoLoadObserver.unobserve(state.sentinel);
    state.loading = true;
    state.loadMore.disabled = true;
    state.loadMore.hidden = true;
    state.sentinel.hidden = false;
    setAutoLoadIndicator(state, true);
    state.status.textContent = 'Loading more matching products.';

    fetchFragmentWithTimeout(requestUrl, state.controller ? state.controller.signal : undefined)
      .then(function (fragment) {
        var added = appendPrefixCards(state, fragment);
        state.loading = false;
        state.autoLoadFailed = false;
        setAutoLoadIndicator(state, false);
        added += updateNext(state, fragment);
        if (state.nextUrl) {
          state.status.textContent = added +
            (added === 1 ? ' matching product loaded.' : ' matching products loaded.');
        } else {
          state.status.textContent = 'All ' + state.total +
            ' matching products shown. Similar matches follow.';
        }

        /* A relevance page can contain only products already shown. Skip it
         * automatically so the scroll sentinel never stalls on duplicates. */
        if (!added && state.nextUrl && state.autoLoadSupported) {
          window.setTimeout(function () { loadNextPage(state); }, 0);
        }
      })
      .catch(function (error) {
        state.loading = false;
        setAutoLoadIndicator(state, false);
        state.autoLoadFailed = true;
        state.sentinel.hidden = true;
        state.loadMore.hidden = false;
        state.loadMore.disabled = false;
        state.loadMore.textContent = 'Try loading matching products again';
        state.status.textContent = 'More matching products could not be loaded. Use the retry button.';
      });
  }

  function bindProgressiveLoading(state) {
    state.loadMore.addEventListener('click', function () {
      if (!state.nextUrl || state.loading) return;
      state.autoLoadFailed = false;
      loadNextPage(state);
    });

    if (!state.autoLoadSupported) return;
    try {
      state.autoLoadObserver = new IntersectionObserver(function (entries) {
        var shouldLoad = entries.some(function (entry) { return entry.isIntersecting; });
        if (shouldLoad && state.nextUrl && !state.loading) loadNextPage(state);
      }, {
        root: null,
        rootMargin: '1400px 0px',
        threshold: 0
      });
    } catch (error) {
      state.autoLoadSupported = false;
      state.autoLoadObserver = null;
    }
  }

  function initializePrefixFirst() {
    var page;
    var params;
    var term;
    var query;
    var controller;
    var loaderGate;
    var requestTimer;
    var priorityQueryValue;
    var priorityRequest;
    var predictiveRequest;
    var hasActiveFilters = false;

    if (initialized || !isPhase8Search()) return;
    if (window.location.search.indexOf('view=' + PREFIX_VIEW) !== -1) return;

    page = document.querySelector('.kjs-search-results-page');
    if (!page) return;

    params = new URLSearchParams(window.location.search);
    if (Number(params.get('page') || 1) > 1) return;
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 && normalizedTerm(value)) {
        hasActiveFilters = true;
      }
    });
    /* Shopify can fail open advanced field queries when storefront filters
     * are present. Keep the server-rendered native results for filtered
     * searches rather than risk relabelling the catalogue as direct matches. */
    if (hasActiveFilters) return;
    term = normalizedTerm(params.get('q'));
    query = prefixQuery(term);
    if (!query || query.toLowerCase() === term.toLowerCase()) return;

    initialized = true;
    controller = 'AbortController' in window ? new AbortController() : null;
    loaderGate = createFuzzyLoaderGate(page);
    if (controller) {
      requestTimer = window.setTimeout(function () {
        controller.abort();
      }, PREFIX_REQUEST_TIMEOUT);
    }
    document.body.classList.add('kjs-prefix-search-loading');
    page.setAttribute('aria-busy', 'true');

    priorityQueryValue = customerSelectedSort() ? '' : priorityQuery(term);
    priorityRequest = priorityQueryValue && priorityQueryValue !== query ?
      fetchFragment(
        prefixFragmentUrl(priorityQueryValue),
        controller ? controller.signal : undefined
      ).catch(function () { return null; }) : Promise.resolve(null);
    predictiveRequest = !customerSelectedSort() &&
      typeof window.KjsPhase8PredictiveOrder === 'function' ?
      window.KjsPhase8PredictiveOrder(term, controller ? controller.signal : undefined)
        .catch(function () { return []; }) : Promise.resolve([]);

    Promise.all([
      fetchFragment(prefixFragmentUrl(query), controller ? controller.signal : undefined),
      priorityRequest,
      predictiveRequest
    ])
      .then(function (fragments) {
        var fragment = fragments[0];
        var priorityFragment = fragments[1];
        (fragments[2] || []).forEach(function (handle, index) {
          predictiveRanks[handle] = index;
        });
        var count = Number(fragment.getAttribute('data-kjs-prefix-count') || 0);
        var sourceGrid = fragment.querySelector('[data-kjs-prefix-grid]');
        var priorityGrid = priorityFragment && priorityFragment.querySelector('[data-kjs-prefix-grid]');
        var priorityUsable = Boolean(priorityGrid && directCards(priorityGrid).some(function (card) {
          var handle = cardHandle(card);
          return handle && handle !== SHIPSKETCH_HANDLE;
        }));
        var usableCards = (sourceGrid && directCards(sourceGrid).some(function (card) {
          var handle = cardHandle(card);
          return handle && handle !== SHIPSKETCH_HANDLE;
        })) || priorityUsable;
        if (!priorityUsable) priorityFragment = null;
        var stateFragment = count || !priorityFragment ? fragment : priorityFragment;
        var state;
        var added;

        if (!usableCards) {
          loaderGate.resume();
          return;
        }
        state = buildState(page, term, stateFragment, loaderGate);
        state.total = Math.max(
          count,
          Number(priorityFragment && priorityFragment.getAttribute('data-kjs-prefix-count') || 0)
        );
        /* Initial exact/predictive requests share a time-limited controller.
         * Use a fresh controller for later autoload pages so an ancillary
         * request that reaches the initial deadline cannot stall pagination. */
        state.controller = 'AbortController' in window ? new AbortController() : null;
        if (priorityFragment) {
          state.priorityLoading = true;
          state.pendingBroadFragment = fragment;
          added = appendPrefixCards(state, priorityFragment);
        } else {
          added = appendPrefixCards(state, fragment);
        }
        if (!added) {
          restoreNativeResults(state);
          return;
        }

        updateNativeIntro(state);
        observeFuzzyResults(state);
        bindProgressiveLoading(state);
        added += updateNext(state, priorityFragment || fragment);
        state.status.textContent = added +
          (added === 1 ? ' matching product shown first.' : ' matching products shown first.');
      })
      .catch(function (error) {
        loaderGate.resume();
        if (error && error.name === 'AbortError') return;
        /* Fail open: Shopify's native fuzzy results remain unchanged. */
      })
      .then(function () {
        window.clearTimeout(requestTimer);
        document.body.classList.remove('kjs-prefix-search-loading');
        page.removeAttribute('aria-busy');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(initializePrefixFirst, 0);
    });
  } else {
    window.setTimeout(initializePrefixFirst, 0);
  }
}());

